import * as React from "react";

const SvgLocalizationStation = ({ ...props }) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  width="1309.000000pt" height="709.000000pt" viewBox="0 0 1309.000000 709.000000"
  preserveAspectRatio="xMidYMid meet"     {...props}>
 
 <g transform="translate(0.000000,709.000000) scale(0.100000,-0.100000)"
    fill="currentColor" stroke="currentColor" strokeWidth={30}>
 <path d="M5920 6336 c0 -91 -2 -105 -17 -110 -10 -3 -56 -14 -103 -25 -112
 -26 -277 -81 -392 -132 -165 -72 -373 -192 -363 -209 3 -5 0 -12 -6 -16 -8 -5
 -9 -3 -4 6 5 8 3 11 -6 8 -8 -3 -14 -10 -14 -16 0 -5 -4 -14 -9 -19 -5 -5 -6
 -2 -1 6 5 9 3 12 -6 9 -8 -3 -13 -10 -12 -16 1 -5 -5 -16 -15 -24 -15 -12 -16
 -11 -3 5 7 9 9 17 3 17 -12 0 -34 -25 -27 -32 3 -3 -3 -11 -12 -19 -16 -13
 -17 -12 -4 4 7 9 9 17 4 17 -11 0 -168 -133 -244 -207 l-56 -54 -44 48 c-280
 304 -713 549 -1143 648 -185 42 -472 68 -487 44 -12 -19 -12 -4799 0 -4818 16
 -24 260 -3 461 40 132 29 290 78 290 90 0 6 -6 9 -12 6 -45 -16 -198 -58 -278
 -76 -126 -27 -213 -39 -342 -47 l-108 -7 0 2403 0 2403 108 -7 c450 -29 888
 -190 1236 -454 107 -81 306 -265 306 -283 0 -5 -25 -35 -55 -67 -58 -63 -74
 -92 -27 -51 l27 24 -24 -27 c-14 -16 -27 -26 -29 -23 -7 7 -32 -15 -32 -27 0
 -6 8 -4 18 3 15 13 16 12 3 -4 -8 -9 -16 -15 -19 -12 -7 7 -32 -15 -32 -27 0
 -6 8 -4 18 3 15 13 16 12 3 -4 -8 -9 -16 -15 -19 -12 -7 6 -32 -15 -32 -27 0
 -5 5 -6 12 -2 7 5 8 3 4 -5 -5 -7 -11 -10 -14 -7 -7 7 -32 -13 -32 -26 0 -5 6
 -6 13 -2 7 4 9 3 4 -2 -5 -5 -14 -9 -20 -9 -5 0 -12 -6 -15 -14 -3 -9 0 -11 8
 -6 9 5 11 4 6 -4 -4 -6 -11 -9 -16 -6 -5 3 -14 -3 -19 -14 -14 -26 -14 -34 2
 -25 7 4 9 3 4 -2 -5 -5 -14 -9 -20 -9 -5 0 -12 -6 -15 -14 -3 -9 0 -11 8 -6 9
 5 11 4 6 -4 -4 -6 -11 -9 -16 -6 -5 3 -14 -3 -19 -14 -14 -26 -14 -34 1 -25 7
 4 8 3 4 -5 -4 -6 -11 -9 -16 -6 -11 7 -106 -179 -159 -312 -115 -288 -165
 -557 -165 -883 0 -326 50 -595 165 -883 53 -133 148 -319 159 -312 5 3 12 0
 16 -6 4 -8 3 -9 -4 -5 -15 9 -15 1 -1 -25 5 -11 14 -17 19 -14 5 3 12 0 16 -6
 5 -8 3 -9 -6 -4 -8 5 -11 3 -8 -6 3 -8 10 -14 16 -14 5 0 14 -4 19 -9 5 -5 3
 -6 -4 -2 -16 9 -16 1 -2 -25 5 -11 14 -17 19 -14 5 3 12 0 16 -6 5 -8 3 -9 -6
 -4 -8 5 -11 3 -8 -6 3 -8 10 -14 16 -14 5 0 14 -4 19 -9 5 -5 3 -6 -4 -2 -7 4
 -13 3 -13 -2 0 -12 25 -33 32 -27 3 3 11 -3 19 -12 13 -16 12 -17 -3 -4 -10 7
 -18 9 -18 3 0 -12 25 -34 32 -27 3 3 11 -3 19 -12 13 -16 12 -17 -3 -4 -10 7
 -18 9 -18 3 0 -12 25 -34 32 -27 3 3 11 -3 19 -12 13 -16 12 -17 -3 -4 -38 29
 -15 -7 52 -83 39 -43 70 -82 70 -86 0 -14 -207 -207 -288 -268 -157 -120 -358
 -235 -539 -308 -40 -16 -73 -32 -73 -36 0 -13 12 -10 95 26 294 124 548 295
 760 515 l59 61 56 -54 c75 -73 232 -206 243 -206 5 0 3 8 -4 18 -13 15 -12 16
 4 3 9 -8 15 -16 12 -19 -7 -7 15 -32 27 -32 6 0 4 8 -3 18 -13 15 -12 16 3 4
 10 -8 16 -19 15 -24 -1 -6 4 -13 12 -16 9 -3 11 0 6 9 -5 8 -4 11 1 6 5 -5 9
 -14 9 -19 0 -6 6 -13 14 -16 9 -3 11 0 6 8 -5 9 -4 11 4 6 6 -4 9 -11 6 -16
 -5 -9 83 -67 185 -123 160 -87 398 -178 570 -218 47 -11 93 -22 103 -25 16 -5
 17 -49 17 -750 0 -489 3 -744 10 -744 7 0 10 255 10 745 l0 745 23 -5 c184
 -41 617 -44 800 -5 l37 8 0 -744 c0 -489 3 -744 10 -744 7 0 10 255 10 744 l0
 743 113 28 c61 15 164 45 227 67 134 45 404 173 396 187 -4 5 -1 13 5 17 8 4
 9 3 5 -4 -11 -18 3 -14 51 14 24 14 41 29 38 34 -3 5 0 12 6 16 8 4 9 3 5 -4
 -10 -17 6 -15 32 4 12 8 20 19 17 24 -3 5 0 12 6 16 8 5 9 3 4 -6 -5 -8 -3
 -11 6 -8 8 3 13 10 12 16 -1 5 5 16 15 24 15 12 16 11 3 -4 -18 -24 -6 -23 30
 3 16 11 27 24 24 29 -3 4 3 14 13 21 15 13 16 12 3 -3 -7 -10 -10 -18 -6 -18
 13 0 95 72 90 80 -2 4 10 20 28 36 l32 29 -30 -34 c-51 -58 -10 -29 69 48 72
 69 97 100 59 70 -10 -7 -7 -1 6 14 25 28 43 38 21 12 -29 -35 3 -11 48 37 l49
 52 64 -70 c435 -475 981 -737 1601 -771 109 -6 121 -5 115 10 -4 10 -2 14 6
 11 9 -3 12 534 12 2396 0 1862 -3 2399 -12 2396 -8 -3 -10 1 -6 11 6 15 -6 16
 -113 10 -322 -16 -611 -93 -904 -239 -280 -139 -488 -298 -704 -537 l-58 -65
 -50 52 c-45 48 -77 72 -48 37 24 -28 4 -15 -26 17 -21 23 -22 27 -5 13 49 -41
 14 2 -60 73 -77 73 -116 98 -63 40 l29 -33 -32 29 c-18 16 -30 32 -28 36 5 8
 -77 80 -90 80 -4 0 -1 -8 6 -17 13 -16 12 -17 -3 -4 -10 7 -16 17 -13 21 5 8
 -46 50 -60 50 -4 0 -1 -8 6 -17 11 -16 11 -16 -1 -5 -8 7 -15 18 -15 24 0 6
 -6 13 -14 16 -9 3 -11 0 -6 -8 5 -9 4 -11 -4 -6 -6 4 -9 11 -6 16 3 5 -5 16
 -17 24 -26 19 -42 21 -32 4 4 -7 3 -8 -5 -4 -6 4 -9 11 -6 16 3 5 -14 20 -38
 34 -48 28 -62 32 -51 14 4 -7 3 -8 -5 -4 -6 4 -9 11 -6 16 7 12 -200 116 -325
 163 -92 35 -251 83 -357 107 l-53 12 0 104 0 104 -450 0 -450 0 0 -104z m880
 -10 l0 -94 -37 8 c-183 39 -616 36 -800 -5 -23 -5 -23 -4 -23 90 l0 95 430 0
 430 0 0 -94z m-487 -73 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z
 m140 0 c-24 -2 -62 -2 -85 0 -24 2 -5 4 42 4 47 0 66 -2 43 -4z m3497 -2394
 l0 -2402 -107 7 c-468 30 -903 194 -1271 480 -107 83 -268 236 -332 318 -35
 44 -38 46 -56 30 -18 -17 -18 -16 0 5 10 13 22 20 26 18 5 -3 31 24 59 59 51
 64 62 83 39 70 -8 -4 -10 -3 -5 2 5 5 14 9 19 9 6 0 13 6 16 14 3 9 0 11 -9 6
 -8 -5 -11 -4 -6 1 5 5 14 9 19 9 6 0 13 6 16 14 3 9 0 11 -8 6 -9 -5 -11 -4
 -6 4 4 6 11 9 16 6 5 -3 18 8 29 24 23 32 27 46 9 35 -7 -4 -8 -3 -4 5 4 6 11
 9 16 6 5 -3 16 8 25 24 18 36 19 45 3 35 -7 -4 -8 -3 -4 5 4 6 11 9 16 6 12
 -8 53 73 44 87 -4 7 -3 8 4 4 14 -8 46 50 38 70 -3 8 -2 13 3 10 20 -13 120
 249 169 439 59 230 67 305 67 595 0 287 -8 359 -65 590 -46 183 -151 457 -171
 444 -5 -3 -6 2 -3 10 8 20 -24 78 -38 70 -7 -4 -8 -3 -4 4 9 14 -32 95 -44 87
 -5 -3 -12 0 -16 6 -4 8 -3 9 4 5 16 -10 15 -1 -3 35 -9 16 -20 27 -25 24 -5
 -3 -12 0 -16 6 -4 8 -3 9 4 5 18 -11 14 3 -9 35 -11 16 -24 27 -29 24 -5 -3
 -12 0 -16 6 -5 8 -3 9 6 4 8 -5 11 -3 8 6 -3 8 -10 14 -15 14 -6 0 -15 4 -20
 9 -5 5 -2 6 6 1 9 -5 12 -3 9 6 -3 8 -10 14 -15 14 -6 0 -15 4 -20 9 -5 5 -3
 6 5 2 23 -13 12 6 -39 70 -28 35 -54 62 -59 59 -4 -2 -16 5 -26 18 -18 21 -18
 22 0 5 18 -16 21 -14 56 31 58 74 218 229 309 301 133 105 246 176 411 258
 234 117 479 193 715 221 50 6 101 13 115 15 14 2 55 4 93 5 l67 1 0 -2401z
 m-3797 2384 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m454 1
 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m96 -11 c-7 -2 -19 -2
 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-696 -9 c-3 -3 -12 -4 -19 -1 -8 3
 -5 6 6 6 11 1 17 -2 13 -5z m190 0 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1
 17 -2 13 -5z m453 -25 c253 -28 535 -111 749 -219 46 -23 90 -39 98 -36 8 3
 11 2 8 -4 -3 -5 3 -14 14 -19 26 -14 34 -14 25 2 -4 7 -3 9 2 4 5 -5 9 -13 9
 -18 0 -7 140 -99 152 -99 2 0 1 5 -3 12 -4 7 -3 8 5 4 6 -4 9 -11 6 -16 -3 -5
 8 -18 24 -29 33 -24 45 -27 35 -8 -4 7 -3 9 2 4 5 -5 9 -12 9 -15 0 -13 16
 -32 27 -32 6 0 5 7 -3 18 -11 15 -11 15 1 4 8 -7 15 -17 15 -22 0 -10 89 -90
 101 -90 4 0 -1 10 -12 23 -10 12 -4 9 14 -7 34 -32 43 -47 15 -25 -10 7 31
 -37 91 -99 60 -61 113 -109 116 -107 4 3 16 -5 26 -18 16 -18 16 -19 2 -8 -31
 23 -20 0 25 -53 24 -28 53 -66 66 -84 12 -18 26 -30 31 -27 5 3 12 0 16 -6 5
 -8 3 -9 -6 -4 -8 5 -11 3 -8 -6 3 -8 10 -14 15 -14 6 0 15 -4 20 -9 5 -5 2 -6
 -6 -1 -9 5 -12 3 -9 -6 3 -8 10 -14 15 -14 6 0 15 -4 20 -9 5 -5 3 -6 -4 -2
 -19 11 -17 6 38 -85 116 -194 204 -405 263 -634 55 -210 70 -340 70 -585 0
 -245 -15 -375 -70 -585 -59 -229 -147 -440 -263 -634 -55 -91 -57 -96 -38 -85
 7 4 9 3 4 -2 -5 -5 -14 -9 -19 -9 -6 0 -13 -6 -16 -14 -3 -9 0 -11 9 -6 8 5
 11 4 6 -1 -5 -5 -14 -9 -19 -9 -6 0 -13 -6 -16 -14 -3 -9 0 -11 8 -6 9 5 11 4
 6 -4 -4 -6 -11 -9 -16 -6 -5 3 -18 -8 -29 -24 -23 -31 -27 -46 -11 -36 16 10
 11 -1 -7 -16 -14 -12 -16 -12 -9 1 4 8 -13 -7 -38 -35 -46 -50 -61 -79 -28
 -54 14 11 13 9 -2 -9 -11 -12 -22 -20 -25 -17 -7 7 -201 -187 -196 -195 2 -4
 -10 -20 -28 -36 -18 -16 -24 -19 -13 -6 11 12 16 22 12 22 -11 0 -101 -80
 -101 -90 0 -5 -4 -12 -9 -17 -5 -5 -6 -3 -2 5 9 16 -10 16 -21 -1 -4 -6 -8
 -15 -8 -19 0 -3 -4 -10 -9 -15 -5 -5 -6 -2 -1 6 5 9 3 12 -6 9 -8 -3 -13 -10
 -12 -16 1 -5 -5 -16 -15 -24 -15 -12 -16 -11 -3 5 8 10 9 17 3 17 -11 0 -27
 -19 -27 -32 0 -3 -4 -10 -9 -15 -5 -5 -6 -3 -2 5 4 6 5 12 2 12 -12 0 -101
 -61 -101 -70 0 -4 -4 -12 -9 -17 -5 -5 -6 -3 -2 5 9 15 1 15 -25 1 -11 -5 -17
 -14 -14 -19 3 -5 0 -12 -6 -16 -8 -4 -9 -3 -5 4 11 19 2 15 -116 -44 -245
 -123 -500 -199 -783 -235 -154 -19 -460 -14 -612 10 -350 55 -680 179 -941
 353 -83 56 -110 69 -97 47 8 -12 6 -12 -8 0 -20 16 -23 25 -4 15 6 -4 3 2 -7
 14 -23 26 -45 30 -25 5 13 -16 12 -17 -4 -4 -9 8 -15 16 -12 19 7 7 -25 42
 -38 42 -5 0 -3 -8 4 -17 13 -16 12 -17 -3 -5 -10 8 -16 17 -15 22 1 4 -43 48
 -98 98 -55 49 -134 129 -175 175 -41 47 -77 84 -81 81 -4 -2 -13 4 -20 14 -13
 15 -12 16 4 3 25 -20 21 2 -5 25 -13 12 -18 13 -13 4 8 -13 7 -13 -8 -1 -18
 15 -23 26 -7 16 17 -10 11 12 -7 26 -15 12 -16 12 -8 -1 8 -13 7 -13 -8 -1
 -18 15 -23 26 -7 16 6 -3 10 -2 10 3 0 13 -25 33 -32 26 -3 -3 -9 0 -14 7 -4
 8 -3 10 4 5 18 -11 15 3 -9 40 -11 19 -25 32 -29 29 -5 -3 -12 0 -16 6 -4 8
 -3 9 4 5 18 -11 15 3 -9 40 -11 19 -25 32 -29 29 -5 -3 -12 0 -16 6 -4 8 -3 9
 4 5 19 -12 15 -1 -42 112 -175 346 -256 684 -256 1070 0 393 79 724 257 1077
 31 61 67 126 79 145 26 38 31 55 12 44 -7 -4 -8 -3 -4 5 4 6 11 9 16 6 4 -3
 18 10 29 29 24 38 26 50 9 40 -7 -4 -11 -5 -8 -1 3 3 10 6 15 7 15 2 35 21 35
 32 0 5 -6 6 -12 2 -7 -4 -11 -5 -8 -1 3 3 8 5 11 4 9 -3 39 24 39 35 0 5 -6 6
 -12 2 -8 -4 -10 -3 -5 2 5 5 10 7 11 4 4 -7 36 21 36 32 0 5 -6 6 -12 2 -9 -5
 -8 -2 1 9 8 10 16 15 19 12 7 -7 32 15 32 27 0 6 -7 5 -15 -2 -28 -24 -15 -4
 17 26 27 23 29 24 13 4 -11 -13 39 34 110 106 72 71 158 151 192 178 35 27 60
 52 58 56 -3 4 3 14 13 21 15 13 16 12 3 -3 -20 -26 2 -22 25 4 10 12 13 18 7
 14 -19 -10 -16 -1 4 15 14 12 16 12 8 0 -13 -22 14 -9 97 47 305 203 712 341
 1103 372 111 9 325 4 455 -11z m-1750 -453 c0 -2 -8 -10 -17 -17 -16 -13 -17
 -12 -4 4 13 16 21 21 21 13z m2980 -21 c13 -14 21 -25 18 -25 -2 0 -15 11 -28
 25 -13 14 -21 25 -18 25 2 0 15 -11 28 -25z m-2970 1 c0 -2 -8 -10 -17 -17
 -16 -13 -17 -12 -4 4 13 16 21 21 21 13z m2960 -21 c13 -14 21 -25 18 -25 -2
 0 -15 11 -28 25 -13 14 -21 25 -18 25 2 0 15 -11 28 -25z m-3010 12 c0 -2 -10
 -12 -22 -23 l-23 -19 19 23 c18 21 26 27 26 19z m10 -20 c0 -2 -10 -12 -22
 -23 l-23 -19 19 23 c18 21 26 27 26 19z m-60 -20 c0 -1 -30 -32 -67 -67 l-68
 -65 65 68 c60 62 70 72 70 64z m10 -20 c0 -1 -53 -54 -117 -117 l-118 -115
 115 118 c107 109 120 122 120 114z m3200 -52 c19 -19 32 -35 29 -35 -3 0 -20
 16 -39 35 -19 19 -32 35 -29 35 3 0 20 -16 39 -35z m40 -70 c47 -47 82 -85 80
 -85 -3 0 -43 38 -90 85 -47 47 -82 85 -80 85 3 0 43 -38 90 -85z m-3410 -18
 c0 -2 -19 -21 -42 -42 l-43 -40 40 43 c36 39 45 47 45 39z m3490 -32 c13 -14
 21 -25 18 -25 -2 0 -15 11 -28 25 -13 14 -21 25 -18 25 2 0 15 -11 28 -25z
 m100 -120 c13 -14 21 -25 18 -25 -2 0 -15 11 -28 25 -13 14 -21 25 -18 25 2 0
 15 -11 28 -25z m-20 -10 c13 -14 21 -25 18 -25 -2 0 -15 11 -28 25 -13 14 -21
 25 -18 25 2 0 15 -11 28 -25z m65 -45 c10 -11 16 -20 13 -20 -3 0 -13 9 -23
 20 -10 11 -16 20 -13 20 3 0 13 -9 23 -20z m-24 -7 c13 -16 12 -17 -3 -4 -10
 7 -18 15 -18 17 0 8 8 3 21 -13z m466 -995 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13
 3 -3 4 -12 1 -19z m-4720 -90 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
 -19z m-10 -80 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m4760 -30
 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-4770 -60 c-3 -7 -5 -2
 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m20 -60 c-3 -7 -5 -2 -5 12 0 14 2 19
 5 13 2 -7 2 -19 0 -25z m4760 0 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19
 0 -25z m-20 -185 c-2 -32 -3 -6 -3 57 0 63 1 89 3 58 2 -32 2 -84 0 -115z
 m-4770 45 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m30 -140 c-3
 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m4760 0 c-3 -7 -5 -2 -5 12
 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-4780 -60 c-3 -7 -5 -2 -5 12 0 14 2 19 5
 13 2 -7 2 -19 0 -25z m4770 -60 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19
 0 -25z m-4760 -20 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m10
 -80 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m4720 -90 c-3 -8 -6
 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-427 -971 c0 -2 -10 -12 -22 -23
 l-23 -19 19 23 c18 21 26 27 26 19z m-70 -50 c0 -2 -10 -12 -22 -23 l-23 -19
 19 23 c18 21 26 27 26 19z m30 0 c0 -2 -12 -14 -27 -28 l-28 -24 24 28 c23 25
 31 32 31 24z m-3694 -49 l29 -33 -32 29 c-31 28 -38 36 -30 36 2 0 16 -15 33
 -32z m-20 -10 l29 -33 -32 29 c-31 28 -38 36 -30 36 2 0 16 -15 33 -32z m169
 -148 c60 -60 107 -110 105 -110 -3 0 -55 50 -115 110 -60 61 -107 110 -105
 110 3 0 55 -49 115 -110z m-95 65 c19 -19 32 -35 29 -35 -3 0 -20 16 -39 35
 -19 19 -32 35 -29 35 3 0 20 -16 39 -35z m3450 -40 c-41 -41 -70 -75 -65 -75
 5 0 19 10 32 22 13 12 23 19 23 17 0 -3 -16 -21 -36 -40 -23 -22 -33 -27 -28
 -15 6 15 4 17 -7 11 -8 -4 22 29 66 74 44 44 82 81 85 81 2 0 -29 -34 -70 -75z
 m90 62 c0 -2 -12 -14 -27 -28 l-28 -24 24 28 c23 25 31 32 31 24z m-3420 -144
 l75 -78 -77 75 c-72 69 -83 80 -75 80 1 0 36 -35 77 -77z m115 -73 c10 -11 16
 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16 20 -13 20 3 0 13 -9 23 -20z m-10
 -20 c10 -11 16 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16 20 -13 20 3 0 13 -9
 23 -20z m3045 17 c0 -2 -12 -14 -27 -28 l-28 -24 24 28 c23 25 31 32 31 24z
 m10 -20 c0 -2 -12 -14 -27 -28 l-28 -24 24 28 c23 25 31 32 31 24z m-3009 -34
 c13 -16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z m1116 -489 c-3
 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m200 0 c-3 -3 -12 -4 -19
 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m490 -10 c-3 -3 -12 -4 -19 -1 -8 3 -5 6
 6 6 11 1 17 -2 13 -5z m-539 -11 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0
 27 -2 18 -5z m449 1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
 m-294 -11 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m135 0 c-21
 -2 -57 -2 -80 0 -24 2 -7 4 37 4 44 0 63 -2 43 -4z"/>
 <path d="M6295 4450 c-134 -18 -236 -70 -340 -174 -85 -85 -148 -201 -166
 -303 -15 -83 -6 -233 16 -293 23 -62 75 -169 85 -175 5 -3 -1 -23 -13 -44
 l-21 -39 36 -40 36 -40 42 19 42 19 54 -30 c100 -58 187 -81 304 -81 121 -1
 189 17 297 77 127 70 244 220 284 364 19 66 17 243 -4 310 -42 139 -153 282
 -274 353 -112 65 -253 94 -378 77z m200 -25 c266 -56 455 -290 455 -565 0
 -276 -189 -509 -459 -565 -232 -49 -474 51 -602 249 -50 75 -75 144 -88 239
 -39 281 129 544 404 630 95 30 186 34 290 12z m-531 -994 c22 -24 15 -36 -25
 -46 -37 -9 -52 12 -37 53 13 34 27 32 62 -7z"/>
 <path d="M6242 4262 c-170 -61 -292 -229 -292 -402 0 -134 75 -272 190 -348
 86 -58 152 -75 259 -70 112 5 195 44 276 129 163 170 162 408 -1 580 -85 88
 -161 122 -284 126 -74 3 -107 -1 -148 -15z m309 -40 c155 -75 250 -256 220
 -423 -23 -135 -101 -242 -219 -300 -56 -28 -81 -34 -153 -37 -107 -5 -173 12
 -257 68 -141 95 -205 282 -153 451 39 122 130 217 253 261 41 14 74 18 148 15
 82 -3 104 -7 161 -35z"/>
 <path d="M2930 6265 c-3 -664 2 -4810 5 -4813 3 -3 5 1080 5 2406 0 1327 -2
 2412 -5 2412 -3 0 -5 -2 -5 -5z"/>
 </g>
 </svg>
);

export default SvgLocalizationStation;
